import React, {useState} from "react";
import CancelIcon from '@mui/icons-material/CancelOutlined';
import CheckCircleIcon from '@mui/icons-material/CheckCircleOutlined';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import { httpClient, isAdminUser } from '../DataProvider';
import {float, padding0, padding2, padding3, textColor, topActionButtonBaseStyle, iconAction} from '../Styles'
import {Grid} from '@mui/material'
import {ActionTitles} from '../Constants'
import {Button} from 'react-admin'
import HourglassDisabledOutlinedIcon from '@mui/icons-material/HourglassDisabledOutlined';
import CustomTooltip from "../../utils/CustomTooltip";

const apiUrl = process.env.REACT_APP_API_ENDPOINT;

function DisableReminder(props) {
  const [open, setOpen] = useState(false);
  const handleClick = () => setOpen(true);
  const isAdmin = isAdminUser();
  const handleConfirm = () => {
    const { clientRequestId } = props;
    const apiEndpoint = isAdmin 
    ? `${apiUrl}/admin/report-request/client/${props.clientId}/request/${clientRequestId}/cancel-scheduled-reminders`
    : `${apiUrl}/api/report-request/${clientRequestId}/cancel-scheduled-reminders` ;
    httpClient(apiEndpoint, {
      method: 'POST'
    })
    .then(() => {
      setOpen(false);
      window.location.reload();
    });
  };
  const handleDialogClose = () => setOpen(false);
  return (
    <React.Fragment>
      {props.scheduledReminders ?
        <CustomTooltip title="Disable reminders" placement="top">
          <Button
            id={`reports-list-disable-reminder-open-button-${props.clientRequestId}`}
            onClick={handleClick}
            sx={iconAction}
            key="button"
          >
            <CheckCircleIcon
              sx={{...textColor.green, fontSize: '1.5rem !important'}}
            />
          </Button>
        </CustomTooltip> :
        <CancelIcon sx={{ ...textColor.red, ...float.left }} />
      }
      <Dialog open={open} onClose={handleDialogClose} fullWidth={true}>
        <DialogContent>
          <p>Disable reminders for <strong>{props.emailAddress}</strong>?</p>
          <p>To restart reminders, resend automated email.</p>
        </DialogContent>
        <DialogActions sx={{...padding0.top, ...padding2.bottom, ...padding3.x}}>
          <Grid container alignItems="center" justifyContent="flex-end">
            <Grid item>
              <Button
                id={`reports-list-disable-reminder-cancel-button-${props.clientRequestId}`}
                onClick={handleDialogClose}
                sx={{...topActionButtonBaseStyle("gray","#fff","#eaeaea","#b2afaf","#9B9999")}}
                size="small"
                variant="outlined"
                label={ActionTitles.CANCEL}
              >
                <CancelIcon/>
              </Button>
              <Button
                id={`reports-list-disable-reminder-confirm-button-${props.clientRequestId}`}
                variant="contained"
                onClick={handleConfirm}
                sx={{...topActionButtonBaseStyle()}}
                size="small"
                label="Disable"
              >
                <HourglassDisabledOutlinedIcon />
              </Button>
            </Grid>
          </Grid>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
};
export default DisableReminder;